import { DialogComponentContent } from './../../models/dialogs/DialogComponentContent';
import { Component, OnInit, ElementRef } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';

@Component({
    selector: 'ir-table',
    templateUrl: './ir-table.component.html',
    styleUrls: ['./ir-table.component.scss']
})
export class IrTableComponent extends DialogComponentContent implements OnInit {

    constructor(
        public dialogRef: MatDialogRef<IrTableComponent>,
        element: ElementRef
    ) {
        super(element);
    }

    ngOnInit() { }

    dispose() {
        this.dialogRef.close()
    }
}